import { useRouter } from 'hooks/useRouter';
import { isEmpty } from 'lodash';
import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect, useRef, useState } from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

const QRCodeGenerator = () => {
  const router = useRouter();
  const { query } = router;

  const [link, setLink] = useState('');
  const [showQRCode, setShowQRCode] = useState(false);
  const [addLogo, setAddLogo] = useState(false);
  const [logoType, setLogoType] = useState('upload');
  const [logo, setLogo] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [logoSize, setLogoSize] = useState({ width: 50, height: 50 });
  const qrRef = useRef(null);

  const handleDownload = () => {
    if (!qrRef.current) return;

    try {
      const canvas = qrRef.current.querySelector('canvas');
      if (!canvas) {
        console.error('Canvas not found inside ref');
        return;
      }

      const dataUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = 'qr-code.png';
      a.click();
    } catch (err) {
      console.error('Error generating image:', err);
    }
  };

  const handleGenerate = () => {
    if (link.trim()) {
      setShowQRCode(true);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setLogo(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const getImageSrc = () => {
    if (!addLogo) return null;
    return logoType === 'upload' ? logo : logoUrl;
  };

  useEffect(() => {
    if (!isEmpty(query?.url)) {
      try {
        const url = atob(query?.url?.trim());
        setLink(url);
        setShowQRCode(true);
      } catch (err) {
        console.warn('URL ERROR', err);
      }
    }
  }, [query?.url]);

  return (
    <div className="page-content">
      <h3 className="mb-4">QR Code Generator</h3>

      <div className="flex flex-col items-center gap-4 p-4 bg-white rounded-md">
        <FormGroup>
          <Label>
            Enter URL
            <span className="text-danger">*</span>
          </Label>
          <textarea
            placeholder="Enter a URL"
            value={link}
            onChange={(e) => {
              setLink(e.target.value);
              setShowQRCode(false);
            }}
            className="form-control"
            rows={4}
          />
        </FormGroup>

        <FormGroup check className="mt-3">
          <Input
            id="logoType"
            type="checkbox"
            checked={addLogo}
            onChange={(e) => {
              setAddLogo(e.target.checked);
              setLogo('');
              setLogoUrl('');
            }}
          />{' '}
          <Label htmlFor="logoType" check>
            Add center logo
          </Label>
        </FormGroup>

        {addLogo && (
          <>
            <FormGroup className="mb-3 mt-3">
              <Label>Choose Logo Type:</Label>
              <div className="d-flex gap-3">
                <FormGroup check>
                  <Input
                    id="upload"
                    type="radio"
                    name="logoType"
                    checked={logoType === 'upload'}
                    onChange={() => setLogoType('upload')}
                  />{' '}
                  <Label className="mb-0" htmlFor="upload" check>
                    Upload
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Input
                    id="url"
                    type="radio"
                    name="logoType"
                    checked={logoType === 'url'}
                    onChange={() => setLogoType('url')}
                  />{' '}
                  <Label className="mb-0" htmlFor="url" check>
                    URL
                  </Label>
                </FormGroup>
              </div>
            </FormGroup>

            {logoType === 'upload' ? (
              <FormGroup className="mb-3">
                <Label>Upload Logo</Label>
                <input type="file" accept="image/*" onChange={handleImageUpload} className="form-control" />
              </FormGroup>
            ) : (
              <FormGroup className="mb-3">
                <Label>Logo URL</Label>
                <input
                  type="text"
                  className="form-control"
                  value={logoUrl}
                  onChange={(e) => setLogoUrl(e.target.value)}
                  placeholder="Enter image URL"
                />
              </FormGroup>
            )}

            <Row>
              <Col md={6}>
                <FormGroup className="mb-3">
                  <Label>Logo Width (px)</Label>
                  <input
                    type="number"
                    className="form-control"
                    value={logoSize.width}
                    onChange={(e) =>
                      setLogoSize({
                        ...logoSize,
                        width: Number(e?.target?.value),
                      })
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-3">
                  <Label>Logo Height (px)</Label>
                  <input
                    type="number"
                    className="form-control"
                    value={logoSize.height}
                    onChange={(e) =>
                      setLogoSize({
                        ...logoSize,
                        height: Number(e?.target?.value),
                      })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
          </>
        )}

        <button disabled={isEmpty(link?.trim())} onClick={handleGenerate} className="btn btn-success mt-3">
          Generate QR Code
        </button>

        {showQRCode && (
          <>
            <button onClick={handleDownload} className="btn btn-primary mt-4 ms-4">
              Download PNG
            </button>

            <div ref={qrRef} className="bg-white p-4 mt-4">
              <QRCodeCanvas
                value={link}
                title="QR Code"
                size={512}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                marginSize={1}
                imageSettings={
                  getImageSrc()
                    ? {
                        src: getImageSrc(),
                        height: logoSize.height,
                        width: logoSize.width,
                        excavate: true,
                      }
                    : undefined
                }
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QRCodeGenerator;
